module.exports = __webpack_public_path__ + "img/Transparent Logo_horizontal.5de24519.svg";